/**
 * Prefixes a state code with the country code "US".
 *
 * @param {string} stateCode - The state code to be prefixed. For example, "TX" for Texas.
 * @returns {string} The prefixed state code in the format "US-<stateCode>". For example, "US-TX".
 */
export function prefixStateCode(stateCode: string) {
  return `US-${stateCode}`;
}

export { formatProvinceCode, formatProvinceCodeForDisplay } from '@/lib/functions/formatProvinceCode';
